import React, { useEffect, useState } from "react";
import { Text, View } from "react-native";
import CustomPressable from "../../components/customPressable/customPressable";
import { CustomDropDown } from "../../components/customDropdown/customDropdown";
import { useCssStyle } from "../../customHook/getCssStyle";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setRenderFlashMessage } from "../../Redux/Actions/appConfigAction";
import { getRoomList } from "../../Redux/Actions/adminPanelAction";
import Loader from "../../components/Loader/loader";


export const RoomSelection = ({ serverConfigInfo, selectedRoom, setSelectedRoom, handleGoHome, handleNext}) => {

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const dispatch = useDispatch();


    const [roomList, setRoomList] = useState([]);
    const [loading, setLoading] = useState(false);

    const [error, setError] = useState(null);

    useEffect(() => {
        fetchRoomList();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchRoomList = async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await dispatch(getRoomList(serverConfigInfo.serverIp));

            console.log("result", result)
            if (result.status === "SUCCESS" && result.data?.locations) {
                // Transform room data to dropdown format
                const rooms = result.data.locations.map(room => ({
                    label: room.locationNumber,
                    value: room.id
                }));
                setRoomList(rooms);
            } else {
                setError(result.message || "Failed to fetch room list");
            }
        } catch (error) {
            console.error('Error fetching room list:', error);
            setError("Something went wrong while fetching room list");
        } finally {
            setLoading(false);
        }
    };

    const handleRoomSelect = (room) => {
        setSelectedRoom(room.value);
    };

    const handleProceed = () => {
        handleNext();  
    };

    return (
        <View style={getStyles(['adminPanelModalChildContainer'])}>

            {loading ? (
                <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                    <Loader size={'large'} style={getStyles(['crossOverContaniner_loader'])} />
                    <Text style={getStyles(['label'])}>{'Fetching rooms...'}</Text>
                </View>
            ) : error ? (
                <>
                    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 20 }}>
                        <Text style={getStyles(['errorText'])}>{error}</Text>
                    </View>
                </>
            ) : (
                <>
                    <View style={getStyles(['textContainer'])}>
                        <CustomDropDown
                            label={t('admin_panel.select_room') || 'Select Room'}
                            placeholder={t('admin_panel.select_room_placeholder')}
                            options={roomList}
                            selectedOption={selectedRoom}
                            onSelectOption={handleRoomSelect}
                            isSearchable={true}
                        />
                    </View>
                </>
            )}

            <View style={getStyles(['adminPanelModalButtonContainer'])} >
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleProceed}>
                    <Text style={getStyles(['primaryBtnTxt'])}>{t('admin_panel.primary_button')}</Text>
                </CustomPressable>

                <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoHome}>
                    <Text style={getStyles(['secondaryBtnTxt'])}>{t('admin_panel.secondary_button')}</Text>
                </CustomPressable>
            </View>
        </View>
    );
}